import React from 'react';

import { Box } from '@ublend-npm/aulaui-core';

export type GreetingTimeOfDay =
  | 'morning'
  | 'afternoon'
  | 'evening'
  | 'welcomeBack';

type GreetingTimeIconProps = {
  timeOfDay: GreetingTimeOfDay;
  sx?: Record<string, unknown>;
};

const MorningSunIcon = () => {
  const id = 'greeting-widget-morning-icon';
  const outerMaskId = `morning-outer-mask-${id}`;
  const innerMaskId = `morning-inner-mask-${id}`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75 72" fill="none">
      <mask
        id={outerMaskId}
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="75"
        height="72"
      >
        <path
          d="M37.5 72C58.2107 72 75 55.8823 75 36C75 16.1178 58.2107 0 37.5 0C16.7893 0 0 16.1178 0 36C0 55.8823 16.7893 72 37.5 72Z"
          fill="white"
        />
      </mask>
      <g mask={`url(#${outerMaskId})`}>
        <path d="M75 0H0V27H75V0Z" fill="#A8D8F0" />
        <path d="M75 27H0V45.9H75V27Z" fill="#6BB8E8" />
        <path d="M75 39H0V47H75V39Z" fill="#B4E8FB" />
        <path d="M75 44.25H0V56.25H75V44.25Z" fill="#A8C3E8" />
        <path d="M75 51H0V72H75V51Z" fill="#7B9FD4" />
        <mask
          id={innerMaskId}
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="75"
          height="40"
        >
          <path d="M75 0H0V39.3H75V0Z" fill="white" />
        </mask>
        <g mask={`url(#${innerMaskId})`}>
          <path
            opacity="0.45"
            d="M37.5 67.25C52.6015 67.25 64.8438 55.4975 64.8438 41C64.8438 26.5025 52.6015 14.75 37.5 14.75C22.3985 14.75 10.1562 26.5025 10.1562 41C10.1562 55.4975 22.3985 67.25 37.5 67.25Z"
            fill="#F8F7F9"
          />
          <g opacity="0.95">
            <path
              d="M35.9375 23.7H39.0625L38.4375 12.6H36.5625L35.9375 23.7Z"
              fill="#513093"
            />
            <path
              d="M45.6782 25.4018L48.3846 26.9018L53.6245 16.9889L52.0007 16.0889L45.6782 25.4018Z"
              fill="#513093"
            />
            <path
              d="M53.2273 31.551L54.7898 34.1491L64.4907 28.0794L63.5532 26.5206L53.2273 31.551Z"
              fill="#513093"
            />
            <path
              d="M20.2102 34.1491L21.7727 31.551L11.4468 26.5206L10.5093 28.0795L20.2102 34.1491Z"
              fill="#513093"
            />
            <path
              d="M26.6157 26.9017L29.3221 25.4017L22.9995 16.0888L21.3757 16.9888L26.6157 26.9017Z"
              fill="#513093"
            />
          </g>
          <path
            d="M37.5 59.1C47.3376 59.1 55.3125 51.4441 55.3125 42C55.3125 32.5559 47.3376 24.9 37.5 24.9C27.6624 24.9 19.6875 32.5559 19.6875 42C19.6875 51.4441 27.6624 59.1 37.5 59.1Z"
            fill="#513093"
          />
          <path
            d="M37.5 54C44.4036 54 50 48.6274 50 42C50 35.3726 44.4036 30 37.5 30C30.5964 30 25 35.3726 25 42C25 48.6274 30.5964 54 37.5 54Z"
            fill="#694AAD"
          />
        </g>
      </g>
    </svg>
  );
};

const AfternoonSunIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 72" fill="none">
    <path
      d="M39.4907 12.2222H45.5092L44.1204 0H40.8796L39.4907 12.2222Z"
      fill="#F5A623"
    />
    <path
      d="M57.8862 17.1438L62.1419 21.2293L70.1623 11.6441L67.8708 9.44421L57.8862 17.1438Z"
      fill="#F5A623"
    />
    <path
      d="M67.2685 33.1111V38.8889L80 37.5556V34.4444L67.2685 33.1111Z"
      fill="#F5A623"
    />
    <path
      d="M62.1425 50.7707L57.8868 54.8562L67.8714 62.5558L70.1629 60.3559L62.1425 50.7707Z"
      fill="#F5A623"
    />
    <path
      d="M45.5093 59.7778H39.4908L40.8796 72H44.1204L45.5093 59.7778Z"
      fill="#F5A623"
    />
    <path
      d="M27.1138 54.8562L22.8581 50.7707L14.8377 60.3559L17.1292 62.5558L27.1138 54.8562Z"
      fill="#F5A623"
    />
    <path
      d="M17.7315 38.8889V33.1111L5 34.4444L5 37.5556L17.7315 38.8889Z"
      fill="#F5A623"
    />
    <path
      d="M22.8575 21.2293L27.1132 17.1438L17.1286 9.44422L14.8371 11.6441L22.8575 21.2293Z"
      fill="#F5A623"
    />
    <path
      d="M42.4998 55.5556C53.75 55.5556 62.8701 46.8002 62.8701 36C62.8701 25.1998 53.75 16.4444 42.4998 16.4444C31.2495 16.4444 22.1294 25.1998 22.1294 36C22.1294 46.8002 31.2495 55.5556 42.4998 55.5556Z"
      fill="#F5A623"
    />
    <path
      d="M42.5001 48.8889C49.9151 48.8889 55.9261 43.1183 55.9261 36C55.9261 28.8817 49.9151 23.1111 42.5001 23.1111C35.0852 23.1111 29.0742 28.8817 29.0742 36C29.0742 43.1183 35.0852 48.8889 42.5001 48.8889Z"
      fill="#FFD166"
    />
  </svg>
);

const EveningMoonIcon = () => {
  const id = 'greeting-widget-evening-icon';
  const outerMaskId = `night-outer-mask-${id}`;
  const innerMaskId = `night-inner-mask-${id}`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" fill="none">
      <mask
        id={outerMaskId}
        style={{ maskType: 'luminance' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="72"
        height="72"
      >
        <path
          d="M36 72C55.8823 72 72 55.8823 72 36C72 16.1178 55.8823 0 36 0C16.1178 0 0 16.1178 0 36C0 55.8823 16.1178 72 36 72Z"
          fill="white"
        />
      </mask>
      <g mask={`url(#${outerMaskId})`}>
        <path d="M72 0H0V24.75H72V0Z" fill="#EF6C00" />
        <path d="M72 24.75H0V41.25H72V24.75Z" fill="#EF6C00" />
        <path d="M72 38.7H0V45.9H72V38.7Z" fill="#FFCC80" />
        <path d="M72 54.45V43.95H36H0V54.45H72Z" fill="#A8C3E8" />
        <path d="M72 51.75H0V72H72V51.75Z" fill="#7B9FD4" />
        <path
          d="M16.5 6.375C16.7071 6.375 16.875 6.20711 16.875 6C16.875 5.79289 16.7071 5.625 16.5 5.625C16.2929 5.625 16.125 5.79289 16.125 6C16.125 6.20711 16.2929 6.375 16.5 6.375Z"
          fill="#FFF9E6"
        />
        <path
          d="M25.5002 3.6C25.6659 3.6 25.8002 3.46569 25.8002 3.3C25.8002 3.13431 25.6659 3 25.5002 3C25.3345 3 25.2002 3.13431 25.2002 3.3C25.2002 3.46569 25.3345 3.6 25.5002 3.6Z"
          fill="#FFF9E6"
        />
        <path
          d="M35.9998 7.44001C36.1323 7.44001 36.2398 7.33256 36.2398 7.20001C36.2398 7.06746 36.1323 6.96001 35.9998 6.96001C35.8672 6.96001 35.7598 7.06746 35.7598 7.20001C35.7598 7.33256 35.8672 7.44001 35.9998 7.44001Z"
          fill="#FFF9E6"
        />
        <path
          d="M49.5 4.575C49.7071 4.575 49.875 4.4071 49.875 4.2C49.875 3.99289 49.7071 3.825 49.5 3.825C49.2929 3.825 49.125 3.99289 49.125 4.2C49.125 4.4071 49.2929 4.575 49.5 4.575Z"
          fill="#FFF9E6"
        />
        <path
          d="M56.25 8.52C56.3991 8.52 56.52 8.39911 56.52 8.25C56.52 8.10088 56.3991 7.98 56.25 7.98C56.1009 7.98 55.98 8.10088 55.98 8.25C55.98 8.39911 56.1009 8.52 56.25 8.52Z"
          fill="#FFF9E6"
        />
        <path
          d="M60.0002 2.99999C60.1659 2.99999 60.3002 2.86568 60.3002 2.69999C60.3002 2.53431 60.1659 2.39999 60.0002 2.39999C59.8345 2.39999 59.7002 2.53431 59.7002 2.69999C59.7002 2.86568 59.8345 2.99999 60.0002 2.99999Z"
          fill="#FFF9E6"
        />
        <path
          d="M11.9999 14.475C12.1242 14.475 12.2249 14.3743 12.2249 14.25C12.2249 14.1257 12.1242 14.025 11.9999 14.025C11.8756 14.025 11.7749 14.1257 11.7749 14.25C11.7749 14.3743 11.8756 14.475 11.9999 14.475Z"
          fill="#FFF9E6"
        />
        <path
          d="M61.4999 15.225C61.6242 15.225 61.7249 15.1243 61.7249 15C61.7249 14.8757 61.6242 14.775 61.4999 14.775C61.3756 14.775 61.2749 14.8757 61.2749 15C61.2749 15.1243 61.3756 15.225 61.4999 15.225Z"
          fill="#FFF9E6"
        />
        <path
          d="M51.7502 13.65L52.1252 15.075L53.5502 15.45L52.1252 15.825L51.7502 17.25L51.3752 15.825L49.9502 15.45L51.3752 15.075L51.7502 13.65Z"
          fill="#FFF9E6"
        />
        <path
          d="M57.5998 18.45L57.9748 19.875L59.3998 20.25L57.9748 20.625L57.5998 22.05L57.2248 20.625L55.7998 20.25L57.2248 19.875L57.5998 18.45Z"
          fill="#FFF9E6"
        />
        <mask
          id={innerMaskId}
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="72"
          height="39"
        >
          <path d="M72 0H0V38.25H72V0Z" fill="white" />
        </mask>
        <g mask={`url(#${innerMaskId})`}>
          <path
            opacity="0.28"
            d="M35.9998 69.9C49.9174 69.9 61.1998 58.6176 61.1998 44.7C61.1998 30.7824 49.9174 19.5 35.9998 19.5C22.0822 19.5 10.7998 30.7824 10.7998 44.7C10.7998 58.6176 22.0822 69.9 35.9998 69.9Z"
            fill="#FFD040"
          />
          <g opacity="0.9">
            <path
              d="M34.6499 28.2H37.3499L36.7499 18H35.2499L34.6499 28.2Z"
              fill="#FFD700"
            />
            <path
              d="M43.0808 29.7356L45.4191 31.0856L47.9764 25.4563L46.6773 24.7063L43.0808 29.7356Z"
              fill="#FFD700"
            />
            <path
              d="M49.6143 35.2809L50.9643 37.6191L59.4978 31.9995L58.7478 30.7005L49.6143 35.2809Z"
              fill="#FFD700"
            />
            <path
              d="M21.0356 37.6191L22.3856 35.2809L13.2521 30.7005L12.5021 31.9995L21.0356 37.6191Z"
              fill="#FFD700"
            />
            <path
              d="M26.581 31.0856L28.9192 29.7356L23.2996 21.2021L22.0006 21.9521L26.581 31.0856Z"
              fill="#FFD700"
            />
          </g>
          <path
            d="M36.0002 60C44.4502 60 51.3002 53.15 51.3002 44.7C51.3002 36.25 44.4502 29.4 36.0002 29.4C27.5502 29.4 20.7002 36.25 20.7002 44.7C20.7002 53.15 27.5502 60 36.0002 60Z"
            fill="#FFD700"
          />
          <path
            d="M35.9998 54.9C41.6331 54.9 46.1998 50.3333 46.1998 44.7C46.1998 39.0667 41.6331 34.5 35.9998 34.5C30.3665 34.5 25.7998 39.0667 25.7998 44.7C25.7998 50.3333 30.3665 54.9 35.9998 54.9Z"
            fill="#FFE94D"
          />
        </g>
        <path
          d="M49.7949 9.45195C46.8459 11.0903 44.8496 14.2367 44.8496 17.8494C44.8498 23.1512 49.1484 27.449 54.4502 27.449C56.7068 27.449 58.7791 26.6673 60.418 25.3641C58.6689 29.4137 54.6418 32.2487 49.9502 32.2488C43.6543 32.2488 38.55 27.1453 38.5498 20.8494C38.5498 14.6051 43.5704 9.53495 49.7949 9.45195Z"
          fill="#E8D8A0"
        />
        <path opacity="0.18" d="M0 44.7H72" stroke="white" strokeWidth="1.2" />
      </g>
    </svg>
  );
};

const NightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 74 71" fill="none">
    <path
      d="M36.9458 70.936C57.3504 70.936 73.8916 55.0564 73.8916 35.468C73.8916 15.8796 57.3504 1.52588e-05 36.9458 1.52588e-05C16.5412 1.52588e-05 0 15.8796 0 35.468C0 55.0564 16.5412 70.936 36.9458 70.936Z"
      fill="#7B9FD4"
    />
    <path
      d="M36.9458 57.7997C49.7931 57.7997 60.208 47.8014 60.208 35.468C60.208 23.1345 49.7931 13.1363 36.9458 13.1363C24.0984 13.1363 13.6836 23.1345 13.6836 35.468C13.6836 47.8014 24.0984 57.7997 36.9458 57.7997Z"
      fill="#A8C3E8"
    />
    <path
      d="M36.9458 0C57.3501 0.000245413 73.891 15.8796 73.8911 35.4678C73.8911 39.7255 73.1081 43.8076 71.6753 47.5898C67.1028 49.8168 61.9308 51.0732 56.4526 51.0732C37.8436 51.0732 22.7573 36.5912 22.7573 18.7266C22.7574 12.1743 24.7886 6.07796 28.2769 0.983398C31.0573 0.341592 33.9602 0 36.9458 0Z"
      fill="#513093"
    />
  </svg>
);

const ICONS: Record<GreetingTimeOfDay, React.FC> = {
  morning: MorningSunIcon,
  afternoon: AfternoonSunIcon,
  evening: EveningMoonIcon,
  welcomeBack: NightIcon,
};

export const getGreetingTimeOfDay = (): GreetingTimeOfDay => {
  const hour = new Date().getHours();
  if (hour < 6) return 'welcomeBack';
  if (hour < 12) return 'morning';
  if (hour < 18) return 'afternoon';
  return 'evening';
};

export const GREETING_TIME_LABELS: Record<GreetingTimeOfDay, string> = {
  morning: 'Good morning',
  afternoon: 'Good afternoon',
  evening: 'Good evening',
  welcomeBack: 'Welcome back',
};

export const GREETING_TIME_ICON_LABELS: Record<GreetingTimeOfDay, string> = {
  morning: 'Morning',
  afternoon: 'Afternoon',
  evening: 'Evening',
  welcomeBack: 'Night',
};

const GreetingTimeIcon = ({ timeOfDay, sx }: GreetingTimeIconProps) => {
  const Icon = ICONS[timeOfDay];

  return (
    <Box
      role="img"
      tabIndex={0}
      aria-label={`${GREETING_TIME_ICON_LABELS[timeOfDay]} time of day`}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        ...sx,
      }}
    >
      <Icon />
    </Box>
  );
};

export default GreetingTimeIcon;
